module.exports = __webpack_public_path__ + "static/img/fenzu2.b5b2873.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/fenzu2.png
// module id = oeDY
// module chunks = 24